export default __webpack_public_path__ + "static/media/banner_home.65bda493.jpg";